import React from 'react';
import { Button } from 'react-bootstrap';

import { LoaderIcon } from './LoaderIcon';

type RefreshButtonProps = {
    refreshFunction: () => void;
    isRefreshing: boolean;
    className?: string;
}

export const RefreshButton = ({ refreshFunction, isRefreshing, className = '' }: RefreshButtonProps) => (
    <Button className={`p-0 ${className}`} variant="link" onClick={refreshFunction}>
        <LoaderIcon animate={isRefreshing} />
    </Button>
);
